import {CREATE_CAMPAIGN,CREATE_CAMPAIGN_DATE,CREATE_CAMPAIGN_START,CREATE_CAMPAIGN_END, GET_CAMPAIGN_FIELD, GET_UNAPPROVED_FILES}
from './type'
import { validateToken, redirectToLogin } from '../../utils/auth/tokenValidation';

interface Action {
  type: string;
  payload?: any; 
  loading?: boolean;
}

type Dispatch = (action: Action) => any;

const API_URL = process.env.REACT_APP_API_URL


export const createCampaign = (campaignData: any): any => async (dispatch: Dispatch): Promise<any> =>{

  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }

  try {
      dispatch({ type: CREATE_CAMPAIGN_START, loading: true });
      const token = localStorage.getItem("loginToken");
      if (!token) {
        throw new Error("Authorization token not found");
      
        
    }
      const response = await fetch(`${API_URL}/campaign/create`, {
          method: "POST",
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify(campaignData) 
      });
      const res = await response.json();
      if (response.ok) {
          dispatch({ type: CREATE_CAMPAIGN, payload: res, loading: false });
          return { success: true, ...res };
      } else {
          dispatch({ type: CREATE_CAMPAIGN_END, payload: res, loading: false });
          return { success: false, message: res.exceptionMsg || res.message || 'Failed to create campaign' };
      }
  } catch (error: any) {
      dispatch({ type: CREATE_CAMPAIGN_END, payload: error.message, loading: false });
      return { success: false, message: error.message };
  }
};


export const updateCampaign = (campaignData: any): any => async (dispatch: Dispatch): Promise<any> =>{
  
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  
  try {
      dispatch({ type: CREATE_CAMPAIGN_START, loading: true });
      const token = localStorage.getItem("loginToken");
      if (!token) {
        throw new Error("Authorization token not found");
        
    }

      const response = await fetch(`${API_URL}/campaign/update`, {
          method: "PUT",
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,

          },
          body: JSON.stringify(campaignData),
      });

      const res = await response.json();

      if (res.loginToken) {

          dispatch({ type: CREATE_CAMPAIGN, payload: res, loading: false });



          return { success: true, ...res }; 
      } else {
          dispatch({ type: CREATE_CAMPAIGN_END, payload: res.message, loading: false });
          return { success: false, ...res }; 
      }
  } catch (error: any) {
      dispatch({ type: CREATE_CAMPAIGN_END, payload: error.message, loading: false });
      return { success: false, message: error.message };
  }
};


export const getByID = (currentCampaignId: string): any => async (dispatch: Dispatch): Promise<any> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  
  try {
    dispatch({ type: CREATE_CAMPAIGN_START, loading: true });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/campaign/get-campaign/${currentCampaignId}`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const res = await response.json();

    if (response.ok) {
      dispatch({ type: CREATE_CAMPAIGN_DATE, payload: res, loading: false });
      return { success: true, ...res };
    } else {
      dispatch({ type: CREATE_CAMPAIGN_END, payload: res.message, loading: false });
      return { success: false, ...res };
    }
  } catch (error: any) {
    dispatch({ type: CREATE_CAMPAIGN_END, payload: error.message, loading: false });
    return { success: false, message: error.message };
  }
};


export const getUnapprovedFiles = (): any => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  try {
    dispatch({ type: CREATE_CAMPAIGN_START, loading: true });
    const token = localStorage.getItem("loginToken");
    if (!token) throw new Error("Authorization token not found");
    const response = await fetch(`${API_URL}/file/get-uploaded-files/0/1000`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    const res = await response.json();
    if (response.ok) {
      dispatch({ type: GET_UNAPPROVED_FILES, payload: res, loading: false });
      return { success: true, data: res };
    } else {
      dispatch({ type: CREATE_CAMPAIGN_END, payload: res.message, loading: false });
      return { success: false, ...res };
    }
  } catch (error: any) {
    dispatch({ type: CREATE_CAMPAIGN_END, payload: error.message, loading: false });
    return { success: false, message: error.message };
  }
};


export const getField = (): any => async (dispatch: Dispatch): Promise<any> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  
  try {
    dispatch({ type: CREATE_CAMPAIGN_START, loading: true });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/filter-fields/getAll`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const res = await response.json();

    if (response.ok) {
      dispatch({ type: GET_CAMPAIGN_FIELD, payload: res, loading: false });
      return { success: true, ...res };
    } else {
      dispatch({ type: CREATE_CAMPAIGN_END, payload: res.message, loading: false });
      return { success: false, ...res };
    }
  } catch (error: any) {
    dispatch({ type: CREATE_CAMPAIGN_END, payload: error.message, loading: false });
    return { success: false, message: error.message };
  }
};



export const getAllBranches = (institutionId: number): any => async (dispatch: Dispatch): Promise<any> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  
  try {
    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/dropdown/get-all-branches?institutionId=${institutionId}`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const res = await response.json();

    if (response.ok && res.status === "200") {
      return { success: true, data: res.data };
    } else {
      return { success: false, message: res.message || 'Failed to fetch branches' };
    }
  } catch (error: any) {
    return { success: false, message: error.message };
  }
};


export const getAllBins = (): any => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  try {
    const token = localStorage.getItem("loginToken");
    if (!token) throw new Error("Authorization token not found");
    const response = await fetch(`${API_URL}/dropdown/get-all-bins`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    const res = await response.json();
    if (response.ok) {
      return { success: true, data: res.data };
    } else {
      return { success: false, message: res.message || 'Failed to fetch BINs' };
    }
  } catch (error: any) {
    return { success: false, message: error.message };
  }
};

export const getAllTransactions = (): any => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  try {
    const token = localStorage.getItem("loginToken");
    if (!token) throw new Error("Authorization token not found");
    const response = await fetch(`${API_URL}/dropdown/get-all-transactions`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    const res = await response.json();
    if (response.ok) {
      return { success: true, data: res.data };
    } else {
      return { success: false, message: res.message || 'Failed to fetch transactions' };
    }
  } catch (error: any) {
    return { success: false, message: error.message };
  }
};

export const getProductsByBin = (binId: number): any => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  try {
    const token = localStorage.getItem("loginToken");
    if (!token) throw new Error("Authorization token not found");
    const response = await fetch(`${API_URL}/dropdown/get-all-products?binId=${binId}`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    const res = await response.json();
    if (response.ok) {
      return { success: true, data: res.data };
    } else {
      return { success: false, message: res.message || 'Failed to fetch products' };
    }
  } catch (error: any) {
    return { success: false, message: error.message };
  }
};

export const getReportTypes = (): any => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  try {
    const token = localStorage.getItem("loginToken");
    if (!token) throw new Error("Authorization token not found");
    const response = await fetch(`${API_URL}/campaign/report-types`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    const res = await response.json();
    if (response.ok) {
      return { success: true, data: res.data ?? res };
    } else {
      return { success: false, message: res.message || 'Failed to fetch report types' };
    }
  } catch (error: any) {
    return { success: false, message: error.message };
  }
};
